import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useTelegram } from './useTelegram'

export const useCopyToClipboard = (): {
  copyUrlToClipboard: (url: string) => Promise<void>
} => {
  const { tg, isTelegramVersionSupported } = useTelegram()
  const { formatMessage } = useIntl()

  const copyUrlToClipboard = useCallback(
    async (url: string) => {
      try {
        // Add haptic feedback only if supported
        if (isTelegramVersionSupported(6.1)) {
          tg.HapticFeedback.impactOccurred('light')
        }

        if (navigator.clipboard) {
          await navigator.clipboard.writeText(url)
          if (isTelegramVersionSupported(6.1)) {
            tg.HapticFeedback.notificationOccurred('success')
          }
        } else {
          // Fallback - show the link
          if (isTelegramVersionSupported(6.1)) {
            tg.showPopup({
              title: formatMessage({
                id: 'share.linkTitle',
                defaultMessage: 'Ваша ссылка',
              }),
              message: url,
              buttons: [{ type: 'ok' }],
            })
          } else {
            alert(
              `${formatMessage({
                id: 'share.linkTitle',
                defaultMessage: 'Ваша ссылка',
              })}: ${url}`,
            )
          }
        }
      } catch (error) {
        console.error('Error copying to clipboard:', error)

        if (isTelegramVersionSupported(6.1)) {
          tg.HapticFeedback.notificationOccurred('error')
          tg.showPopup({
            title: formatMessage({
              id: 'share.error.title',
              defaultMessage: 'Ошибка',
            }),

            message: formatMessage({
              id: 'share.error.copyFailed',
              defaultMessage: 'Не удалось скопировать ссылку',
            }),

            buttons: [{ type: 'ok' }],
          })
        } else {
          alert(
            `${formatMessage({
              id: 'share.error.title',
              defaultMessage: 'Ошибка',
            })}: ${formatMessage({
              id: 'share.error.copyFailed',
              defaultMessage: 'Не удалось скопировать ссылку',
            })}`,
          )
        }
      }
    },
    [tg, formatMessage, isTelegramVersionSupported],
  )

  return {
    copyUrlToClipboard,
  }
}
